import { GeneralResponse } from '../models/generalResponse'

export function updateRetry(userRepository, contextData, usersData) {
  return userRepository.updateRetry(contextData, usersData).then(data => new GeneralResponse(data));
}